import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ShareButtons from './ShareButtons';

const NewsHeader = ({ title, subtitle, author, publishedAt, shareUrl }) => {
    const formattedDate = publishedAt 
        ? new Date(publishedAt).toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' })
        : 'Data desconhecida';

    return (
        <Box sx={{ mb: 4 }} data-ui="section-news-header">
            <Typography 
                variant="h2" 
                component="h1" 
                sx={{ 
                    fontWeight: 800, 
                    color: 'text.primary',
                    fontSize: { xs: '2rem', md: '3rem' },
                    lineHeight: 1.2,
                    mb: 2.5,
                }}
            >
                {title}
            </Typography>

            {subtitle && (
                <Typography
                    variant="h6"
                    component="p"
                    sx={{
                        mt: -0.5,
                        mb: 2.5,
                        fontWeight: 500,
                        lineHeight: 1.45,
                        color: 'text.secondary',
                        fontSize: { xs: '1.05rem', md: '1.25rem' },
                        maxWidth: '48em',
                    }}
                    data-ui="news-subtitle"
                >
                    {subtitle}
                </Typography>
            )}

            <Stack direction="row" spacing={3} alignItems="center" sx={{ flexWrap: 'wrap', rowGap: 1.25 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                            {author || 'R5 Editorial'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Autor
                        </Typography>
                    </Box>
                </Stack>

                <Divider orientation="vertical" flexItem />

                <Stack direction="row" spacing={1} alignItems="center">
                    <CalendarTodayIcon color="action" />
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {formattedDate}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Publicação
                        </Typography>
                    </Box>
                </Stack>

                <Divider orientation="vertical" flexItem />

                <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mt: { xs: 0.5, md: 0 } }}>
                    <ShareButtons
                        title={title}
                        description={subtitle}
                        url={shareUrl}
                        iconButtonSx={{
                            width: 34,
                            height: 34,
                            borderRadius: '50%',
                            border: '1px solid rgba(0,0,0,0.10)',
                            bgcolor: '#fff',
                            color: '#3a3a3a',
                            transition: 'all 0.18s ease',
                            '&:hover': {
                                bgcolor: '#f7f7f7',
                                borderColor: 'rgba(0,0,0,0.16)',
                            },
                            '&:focus-visible': {
                                outline: '3px solid #cc0000',
                                outlineOffset: '2px',
                            },
                        }}
                    />
                </Stack>
            </Stack>
        </Box>
    );
};

export default NewsHeader;
